import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=52ee846c&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=52ee846c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee846c",
  null
  
)

export default component.exports